
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-time/[activitySlug]",
      function () {
        return require("private-next-pages/real-time/[activitySlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-time/[activitySlug]"])
      });
    }
  